<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>
        <section class="dp-right">
            <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
            <div class="tbl-scroll-host">
            <el-table :data="users" v-loading="listLoading" style="width: 100%; margin-top: 20px;" height="100%">
                <el-table-column prop="Name" label="姓名" width="" />
                <el-table-column label="关联教师" width="" >
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.TeacherId" type="primary" size="mini" effect="plain">{{ scope.row.TeacherName }}</el-tag>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="DepartmentName" label="所属部门" width=""  />
                <el-table-column label="所属校区" width="" show-overflow-tooltip >
                    <template slot-scope="scope">
                        <el-tag v-if="getCampusName(scope.row.CampusId) !== '-'" size="mini" type="primary" effect="plain">{{ getCampusName(scope.row.CampusId) }}</el-tag>
                        <el-tag v-else size="mini" type="info" effect="plain">未关联校区</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="全校统计" width="" align="center" >
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.CanViewAllClasses ? 'success' : 'info'" size="small">
                            {{ scope.row.CanViewAllClasses ? '是' : '否' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="状态" width="90" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.Enabled ? 'success' : 'danger'">
                            {{ scope.row.Enabled ? '启用' : '禁用' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="Remark" label="备注" show-overflow-tooltip />
                <el-table-column prop="CreateTime" label="创建时间" width="160" align="center" />
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="warning" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button size="mini" type="danger" @click="handleDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            </div>
            <div class="pagination-container">
                <el-pagination layout="total,prev, pager, next" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" :current-page="page" :page-size="PageSize" :total="total"
                    style="float: right" />
            </div>

            <el-dialog :title="dialogTitle" :visible.sync="editFormVisible" width="40%" :close-on-click-modal="false">
                <el-form :model="editForm" label-width="110px" :rules="editFormRules" ref="editForm">
                    <el-form-item label="所属校区" prop="CampusId">
                        <el-select v-model="editForm.CampusId" placeholder="请选择校区" style="width: 100%" clearable
                            @change="handleCampusChange" :disabled="editForm.Id > 0">
                            <el-option v-for="item in campusOptions" :key="item.Id" :label="item.Name" :value="item.Id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="教师" prop="TeacherId">
                        <el-select v-model="editForm.TeacherId" filterable placeholder="请选择教师" :loading="teacherLoading"
                            @change="handleTeacherChange" style="width: 100%" :disabled="editForm.Id > 0">
                            <el-option v-for="item in teacherOptions" :key="item.Id" :label="item.TeacherName"
                                :value="item.Id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="姓名" prop="Name">
                        <el-input v-model="editForm.Name" maxlength="50" />
                    </el-form-item>
                    <el-form-item label="可查看全校统计">
                        <el-switch v-model="editForm.CanViewAllClasses" />
                    </el-form-item>
                    <el-form-item label="启用状态">
                        <el-switch v-model="editForm.Enabled" />
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input type="textarea" v-model="editForm.Remark" :rows="3" maxlength="500" />
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="editFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="editSubmit" :loading="editLoading">确 定</el-button>
                </div>
            </el-dialog>
        </section>
    </section>
</template>

<script>
import { getClassRollCallPrivAdminListPage, addClassRollCallPrivAdmin, editClassRollCallPrivAdmin, removeClassRollCallPrivAdmin, getCampusList } from '../../api/modules/misc';
import { getTeacherMasterList } from '../../api/modules/personnel';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from "../../components/DepartmentPane";

export default {
    components: { Toolbar, DepartmentPane },
    data() {
        return {
            filters: { campusId: null },
            campusOptions: [],
            searchList: [
                { label: "姓名", key: "name" },
                {
                    label: "选择校区",
                    key: "campusId",
                    type: "select",
                    clearable: true,
                    options: [],
                },
            ],
            users: [],
            total: 0,
            page: 1,
            PageSize: 10,
            listLoading: false,
            buttonList: [],
            DepartmentId: 0,
            dialogTitle: "",
            editFormVisible: false,
            editLoading: false,
            teacherOptions: [],
            teacherLoading: false,
            editFormRules: {
                CampusId: [{ required: true, message: "请选择所属校区", trigger: "change" }],
                Name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
                TeacherId: [{ required: true, message: "请选择教师", trigger: "change" }],
            },
            editForm: {
                Id: 0,
                Name: "",
                DepartmentId: 0,
                CampusId: null,
                TeacherId: null,
                CanViewAllClasses: true,
                Enabled: true,
                Remark: "",
            },
        };
    },
    methods: {
        /** 获取顶部当前学校 ID，保留 long 字符串精度。 */
        resolveSchoolId() {
            const candidates = [
                this.$store.state.activeSchoolId,
                typeof window !== 'undefined' ? window.localStorage.getItem('activeSchoolId') : '',
                this.DepartmentId,
            ];
            return candidates.find((id) => /^\d+$/.test(String(id || '')) && String(id) !== '0') || '';
        },
        treeNodeClick(data) {
            this.DepartmentId = data.value;
            // 顶栏切校也会经 DepartmentPane 触发此处，必须清掉旧校区筛选
            this.clearCampusFilter();
            this.loadCampusOptions();
            this.handleQuery();
        },
        handleQuery() {
            this.page = 1;
            this.getUsers();
        },
        getUsers() {
            let para = {
                page: this.page,
                intPageSize: this.PageSize,
                departmentId: this.DepartmentId,
                ...this.filters,
            };
            if (para.campusId === null || para.campusId === undefined) para.campusId = 0;
            this.listLoading = true;
            getClassRollCallPrivAdminListPage(para).then((res) => {
                this.total = res.data.response.dataCount;
                this.users = res.data.response.data;
                this.listLoading = false;
            });
        },
        handleSizeChange(val) {
            this.PageSize = val;
            this.getUsers();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getUsers();
        },
        callFunction(item) {
            if (typeof item.search === "object") {
                this.filters = item.search;
            } else {
                this.filters = { name: item.search };
            }
            this[item.Func].apply(this, item);
        },
        handleAdd() {
            const schoolId = this.resolveSchoolId();
            if (!schoolId) {
                this.$message.warning('请先在顶部选择学校');
                return;
            }
            this.dialogTitle = "新增点到管理员";
            this.editFormVisible = true;
            this.teacherOptions = [];
            this.editForm = {
                Id: 0,
                Name: "",
                DepartmentId: schoolId,
                CampusId: null,
                TeacherId: null,
                CanViewAllClasses: true,
                Enabled: true,
                Remark: "",
            };
            this.loadCampusOptions().then(() => {
                const preset = this.filters.campusId;
                const validPreset = this.isCampusInCurrentSchool(preset) ? preset : null;
                if (validPreset) {
                    this.$set(this.editForm, "CampusId", validPreset);
                    this.loadTeacherListBySchoolAndCampus(validPreset);
                }
            });
            this.$nextTick(() => this.$refs.editForm && this.$refs.editForm.clearValidate());
        },
        handleEdit(row) {
            this.dialogTitle = "编辑点到管理员";
            this.editFormVisible = true;
            this.teacherOptions = [];
            this.editForm = Object.assign({}, row);
            if (this.editForm.CampusId === 0 || this.editForm.CampusId === "0") {
                this.$set(this.editForm, "CampusId", null);
            }
            delete this.editForm.Dids;
            this.loadCampusOptions().then(() => {
                if (row.CampusId) {
                    this.loadTeacherListBySchoolAndCampus(row.CampusId);
                }
            });
            this.$nextTick(() => {
                setTimeout(() => this.$refs.editForm && this.$refs.editForm.clearValidate(), 200);
            });
        },
        handleDel(row) {
            this.$confirm("确认删除该记录吗？", "提示", { type: "warning" }).then(() => {
                this.listLoading = true;
                removeClassRollCallPrivAdmin({ id: row.Id }).then((res) => {
                    this.listLoading = false;
                    if (res.data.success) {
                        this.$message.success("删除成功");
                        this.getUsers();
                    }
                });
            });
        },
        loadCampusOptions() {
            const schoolId = this.resolveSchoolId();
            if (!schoolId) {
                this.campusOptions = [];
                const campusSearch = this.searchList.find((e) => e.key === "campusId");
                if (campusSearch) campusSearch.options = [];
                return Promise.resolve();
            }
            return getCampusList({ page: 1, intPageSize: 999, departmentId: schoolId }).then((res) => {
                if (String(schoolId) !== String(this.resolveSchoolId())) return;
                if (!res.data.success) return;
                this.campusOptions = res.data.response.data || [];
                const campusSearch = this.searchList.find((e) => e.key === "campusId");
                if (campusSearch) {
                    campusSearch.options = this.campusOptions.map((e) => ({
                        label: e.Name,
                        value: e.Id,
                    }));
                }
                // 工具栏/表单若仍挂着他校校区 ID，清掉避免残留名称
                if (!this.isCampusInCurrentSchool(this.filters.campusId)) {
                    this.filters = { ...(this.filters || {}), campusId: null };
                    if (this.$refs.toolbar && this.$refs.toolbar.searchObj) {
                        this.$set(this.$refs.toolbar.searchObj, "campusId", null);
                    }
                }
                if (this.editFormVisible && !this.isCampusInCurrentSchool(this.editForm.CampusId)) {
                    this.$set(this.editForm, "CampusId", null);
                    this.teacherOptions = [];
                }
            });
        },
        /** 校区 ID 是否属于当前学校的校区下拉。最后更新：2026-08-30 */
        isCampusInCurrentSchool(campusId) {
            if (campusId == null || campusId === "" || campusId === 0 || campusId === "0") return false;
            return (this.campusOptions || []).some((c) => String(c.Id) === String(campusId));
        },
        editSubmit() {
            this.$refs.editForm.validate((valid) => {
                if (!valid) return;
                const schoolId = this.resolveSchoolId();
                if (!schoolId) {
                    this.$message.warning('请先在顶部选择学校');
                    return;
                }
                this.editLoading = true;
                const para = Object.assign({}, this.editForm);
                delete para.Dids;
                delete para.DepartmentName;
                delete para.TeacherName;
                // 新增时所属机构固定为顶部学校
                if (!(para.Id > 0)) {
                    para.DepartmentId = schoolId;
                }
                if (para.CampusId == null) {
                    this.$message.error("请选择校区");
                    this.editLoading = false;
                    return;
                }
                const api = para.Id > 0 ? editClassRollCallPrivAdmin : addClassRollCallPrivAdmin;
                api(para)
                    .then((res) => {
                        if (res.data.success) {
                            this.$message.success("提交成功");
                            this.editFormVisible = false;
                            this.getUsers();
                        } else {
                            this.$message.error(res.data.msg || "提交失败");
                        }
                        this.editLoading = false;
                    })
                    .catch(() => {
                        this.editLoading = false;
                    });
            });
        },
        /** 按顶部学校 + 校区加载教师下拉（仅 TeacherCampus 显式关联，与教师信息「关联校区」一致）。最后更新：2026-08-30 */
        loadTeacherListBySchoolAndCampus(campusId) {
            const schoolId = this.resolveSchoolId();
            if (!schoolId) {
                this.teacherLoading = false;
                this.teacherOptions = [];
                this.$message.warning("请先在顶部选择学校");
                return;
            }
            if (!this.isCampusInCurrentSchool(campusId)) {
                this.teacherOptions = [];
                this.$set(this.editForm, "CampusId", null);
                this.$message.warning("校区不属于当前学校，请重新选择");
                return;
            }
            this.teacherLoading = true;
            // campusLinkedOnly：与教师信息管理列表的「关联校区」筛选一致，避免任教部门历史数据“冒出”教师
            const para = {
                page: 1,
                intPageSize: 9999,
                departmentId: schoolId,
                campusId,
                campusLinkedOnly: true,
            };
            getTeacherMasterList(para)
                .then((res) => {
                    this.teacherLoading = false;
                    if (!res.data || !res.data.success) {
                        this.teacherOptions = [];
                        this.$message.error((res.data && res.data.msg) || "加载教师失败");
                        return;
                    }
                    this.teacherOptions = res.data.response || [];
                })
                .catch(() => {
                    this.teacherLoading = false;
                    this.teacherOptions = [];
                });
        },
        handleCampusChange(val) {
            this.editForm.TeacherId = null;
            this.teacherOptions = [];
            if (val) {
                this.loadTeacherListBySchoolAndCampus(val);
            }
        },
        getCampusName(campusId) {
            if (!campusId || campusId === 0 || campusId === "0" || !this.campusOptions.length) return "-";
            const campus = this.campusOptions.find((c) => c.Id === campusId);
            return campus ? campus.Name : "-";
        },
        handleTeacherChange(val) {
            if (val) {
                const teacher = this.teacherOptions.find((t) => t.Id === val);
                if (teacher) this.editForm.Name = teacher.TeacherName;
            }
        },
        /** 清空工具栏校区筛选（切换学校时防止残留旧校区）。最后更新：2026-08-30 */
        clearCampusFilter() {
            this.filters = { ...(this.filters || {}), campusId: null };
            this.campusOptions = [];
            const campusSearch = this.searchList.find((e) => e.key === "campusId");
            if (campusSearch) campusSearch.options = [];
            // 同步清空工具栏选中值，避免 nextTick 期间仍显示旧校区名称
            if (this.$refs.toolbar && this.$refs.toolbar.searchObj) {
                this.$set(this.$refs.toolbar.searchObj, "campusId", null);
            }
        },
        /** 顶部学校切换后重载校区与列表。最后更新：2026-08-30 */
        onActiveSchoolChange(newSchoolId, oldSchoolId) {
            if (String(newSchoolId || "") === String(oldSchoolId || "")) return;
            const schoolId = this.resolveSchoolId();
            this.DepartmentId = schoolId ? Number(schoolId) || schoolId : 0;
            this.clearCampusFilter();
            this.users = [];
            this.total = 0;
            this.page = 1;
            this.teacherOptions = [];
            this.editFormVisible = false;
            this.loadCampusOptions();
            if (schoolId) this.handleQuery();
        },
    },
    watch: {
        "$store.state.activeSchoolId"(newSchoolId, oldSchoolId) {
            this.onActiveSchoolChange(newSchoolId, oldSchoolId);
        },
    },
    mounted() {
        const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
        this.buttonList = getButtonList(this.$route.path, routers);
        if (!this.buttonList.some((b) => b.Func === "handleQuery")) {
            this.buttonList.unshift({ name: "查询", Func: "handleQuery", id: 999 });
        }
        this.loadCampusOptions();
    },
};
</script>

<style scoped>
.pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
}
.dp-layout {
    display: flex;
    height: 100%;
}
.dp-left {
    width: 260px;
    flex-shrink: 0;
    margin-right: 12px;
}
.dp-right {
    flex: 1;
    min-width: 0;
}
</style>
